import StyleDto from '../../../../shared/style.dto';
import useComponentContentStyles from '../../hooks/useComponentContentStyles';

interface MarginProps {
  id: string;
  styles: StyleDto[];
  children: React.ReactNode;
}

const Margin = ({ styles: stylesProp = [], children }: MarginProps) => {
  const { componentStyles, componentContainerRef } = useComponentContentStyles({ stylesProp });

  return (
    <div ref={componentContainerRef} style={componentStyles}>
      {children}
    </div>
  );
};

export default Margin;
